module.exports = __webpack_public_path__ + "static/media/wine-stroll-flyer-2021.340ecd29.pdf";